export default __webpack_public_path__ + "static/media/offline.af2b4047.png";